/** Приклади тіл запитів — узгоджені з testApi/client/src/constants.js */

export const API_DOC_EXAMPLES = {
    createClient: {
        clientName: 'John Smith',
        clientPhone: '+380971112233',
        clientEmail: 'john@example.com',
        clientAddress: 'Kyiv, Ukraine',
        clientDescription: 'Test client from API',
    },
    createLeadWithClient: {
        client: {
            clientName: 'John Smith',
            clientPhone: '+380971112233',
        },
        eventInfo: 'Lead from external CRM',
        sourceLeadId: 2,
        sourceLeadMessage: 'Incoming lead message',
        sourceLeadData: { campaign: 'google_ads' },
    },
    createLeadWithClientId: {
        clientId: 1,
        eventInfo: 'Lead for existing client',
    },
    createProduct: {
        prodArticle: 'ART-1001',
        prodName: 'External item',
        prodDefPrice: 1500,
        prodDefPriceSale: 1700,
        prodDescription: 'Test product',
    },
    warehouseComingByArticle: {
        operationType: 'coming',
        items: [
            {
                prodArticle: 'ART-1001',
                count: 2,
                price: 15.5,
                priceRate: 640.25,
                description: 'Incoming stock by article',
            },
        ],
        payment: { amount: 31, amountRate: 1280.5, description: 'Payment for incoming' },
    },
    warehouseComingByProductId: {
        operationType: 'coming',
        items: [
            {
                productId: 321,
                count: 2,
                price: 15.5,
                description: 'Incoming stock by productId',
            },
        ],
        payment: { amount: 31, description: 'Payment for incoming' },
    },
    warehouseTransferByArticle: {
        operationType: 'transfer',
        whFrom: 1,
        whTo: 2,
        items: [{ prodArticle: 'ART-1001', count: 2, description: 'Transfer by article, auto price' }],
    },
    warehouseTransferByIdent: {
        operationType: 'transfer',
        whIdentFrom: 'main-stock',
        whIdentTo: 'brigade-alpha',
        items: [{ prodArticle: 'ART-1001', count: 2, description: 'Transfer by warehouse API identifiers' }],
    },
    warehouseTransferByPrice: {
        operationType: 'transfer',
        whFrom: 1,
        whTo: 2,
        items: [
            {
                productId: 321,
                count: 2,
                price: 15.5,
                priceRate: 640.25,
                description: 'Transfer by productId with explicit price',
            },
        ],
    },
    webhookEnvelope: {
        event: 'client_create',
        timestamp: 1710000000000,
        data: {
            clientId: 123,
            client: {
                ID: 123,
                clientName: 'John Smith',
                clientPhone: '+380971112233',
            },
        },
    },
} as const;

export type ApiDocExamplePayload = Record<string, unknown>;

export type ApiDocExampleItem = {
    id: string;
    /** i18n key under apiDocs.examples.<id> */
    labelKey: string;
    hintKey?: string;
    payload: ApiDocExamplePayload;
};
